/**
 * @typedef {Object} PaginationData
 * @property {string} first
 * @property {string} last
 * @property {number} total
 */

/**
 *
 * @param {string} template blablabla
 * @param {PaginationData} data
 */
export const readPagination = (template, data) =>
    template.replace(/\{(\w+)\}/g, (rule, item) => data[item]);
